module.exports = __webpack_public_path__ + "static/media/adventure.7f93a9d8.jpg";